import React from 'react';
import GuaranteesTableView from './TableView';
import GuaranteesMobileView from './MobileView';

const Guarantees: React.FC = () => {
    return (
        <div>
            <div className="hidden md:block">
                <GuaranteesTableView />
            </div>
            <div className="block md:hidden">
                <GuaranteesMobileView />
            </div>
        </div>
    );
};

export default Guarantees;
